import { render, staticRenderFns } from "./TabsListLoader.vue?vue&type=template&id=48625c37&scoped=true"
import script from "./TabsListLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabsListLoader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TabsListLoader.vue?vue&type=style&index=0&id=48625c37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48625c37",
  null
  
)

export default component.exports